define('SageDotCom/Utility/FaqSchema',[
    "jquery"
], function ($) {
    function FaqSchema() { }

    FaqSchema.prototype.init = function init() {
        $(document).ready(function () {
            var $faqSchemaCheckedItem = $(".score-accordion .faq-schema-checked");

            if ($faqSchemaCheckedItem.length > 0) {
                var scriptElement = document.createElement("script");
                scriptElement.type = "application/ld+json";

                var $questionText = $(".score-accordion .faq-schema-checked .panel-heading .panel-title button");
                var $answerText = $(".score-accordion .faq-schema-checked .panel-collapse .panel-body");

                var arrayMainEntity = [];

                $faqSchemaCheckedItem.each(function (index) {
                    var mainEntityObj = new Object();
                    var acceptedAnswerObj = new Object();
                    if ($questionText[index]) {
                        mainEntityObj["@type"] = "Question";
                        mainEntityObj["name"] = $questionText[index].innerText.trim();
                        arrayMainEntity.push(mainEntityObj);
                    }

                    if ($answerText[index]) {
                        acceptedAnswerObj["@type"] = "Answer";
                        acceptedAnswerObj["text"] = $answerText[index].innerText.trim();
                        mainEntityObj.acceptedAnswer = acceptedAnswerObj;
                    }
                });

                scriptElement.text = JSON.stringify({ "@context": "http://schema.org", "@type": "FAQPage", "mainEntity": arrayMainEntity });
                document.querySelector("head").appendChild(scriptElement);
            }
        });
    }


    return new FaqSchema();
});
